/*
 *  REST Service object: DocmanFolderRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class DocmanFolderRest {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    getAll(projectId: number) {
        return this.http.get(`/api/docman/${projectId}/folders`)
            .toPromise()
    }

    getFolder(folderId: number) {
        return this.http.get(`/api/docman/${folderId}/folder?rel=currentfiles`)
            .toPromise()
    }

    postFolder(folder: any) {
        let folderId: number = folder.id;
        return this.http.post(`/api/docman/${folderId}/folder`, folder)
            .toPromise()
    }

    deleteFolder(folderId: number) {
        return this.http.delete(`/api/docman/${folderId}/folder`)
            .toPromise()
    }
}
